import { useState } from "react";
import { authService } from "@/services/auth";

interface AdminLoginProps {
  onLogin: () => void;
}

export default function AdminLogin({ onLogin }: AdminLoginProps) {
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [carregando, setCarregando] = useState(false);
  const [mostrarSenha, setMostrarSenha] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErro("");
    setCarregando(true);
    try {
      const { error } = await authService.signIn("admin@trd60d.com", senha);
      if (error) {
        setErro("Senha incorreta. Tente novamente.");
      } else {
        sessionStorage.setItem("admin_auth", "1");
        onLogin();
      }
    } catch {
      setErro("Erro de conexao. Tente novamente.");
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <div className="w-14 h-14 flex items-center justify-center bg-amber-500/20 border border-amber-500/30 rounded-2xl mx-auto mb-4">
            <i className="ri-shield-keyhole-line text-amber-400 text-2xl" />
          </div>
          <h1 className="text-white font-black text-2xl mb-1">Painel Interno</h1>
          <p className="text-white/40 text-sm">Transformacao Real 60D</p>
        </div>
        <div className="bg-white/5 border border-white/10 rounded-2xl p-8">
          <p className="text-white/60 text-sm text-center mb-6">
            Acesso restrito a equipe interna
          </p>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-white/50 text-xs font-semibold uppercase tracking-wider mb-2">
                Senha de acesso
              </label>
              <div className="relative">
                <input
                  type={mostrarSenha ? "text" : "password"}
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  placeholder="••••••••••••"
                  required
                  className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 pr-12 text-white text-sm placeholder-white/20 focus:outline-none focus:border-amber-500/50 transition-colors"
                />
                <button
                  type="button"
                  onClick={() => setMostrarSenha((v) => !v)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center text-white/30 hover:text-white/60 transition-colors cursor-pointer"
                >
                  <i className={mostrarSenha ? "ri-eye-off-line" : "ri-eye-line"} />
                </button>
              </div>
            </div>
            {erro && (
              <div className="flex items-center gap-2 bg-red-950/60 border border-red-800/40 rounded-xl px-4 py-3">
                <i className="ri-error-warning-line text-red-400 text-sm flex-shrink-0" />
                <p className="text-red-400 text-sm">{erro}</p>
              </div>
            )}
            <button
              type="submit"
              disabled={carregando || !senha}
              className="w-full flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-400 disabled:opacity-50 disabled:cursor-not-allowed text-gray-950 font-black text-sm py-3.5 rounded-xl transition-all cursor-pointer whitespace-nowrap"
            >
              {carregando ? (
                <><i className="ri-loader-4-line animate-spin" /><span>Verificando...</span></>
              ) : (
                <><i className="ri-login-box-line" /><span>Entrar no painel</span></>
              )}
            </button>
          </form>
        </div>
        <p className="text-white/20 text-xs text-center mt-6">
          Acesso exclusivo para a equipe Transformacao Real
        </p>
      </div>
    </div>
  );
}
